/** French Workforce & Education Translations */
export const workforce = {
  workforce: {
    pageTitle: "Dimension Main-d'œuvre et Éducation",
    weightInFII: "poids dans le FII",
    heroSubtitle: "Équiper les jeunes avec des compétences pour les opportunités économiques (18-40 ans)",
    quote: "23% des jeunes travailleurs sont sous-employés par rapport à leur éducation, mais 85% des emplois futurs nécessiteront des compétences numériques. L'écart entre éducation et opportunité n'est pas un manque d'apprenants—c'est un manque de parcours alignés et accessibles vers des emplois de qualité.",
    fiiWeightDistribution: "Distribution du poids FII",
    mentalHealth: "Santé Mentale",
    workforceLabel: "Main-d'œuvre",
    entrepreneurship: "Entrepreneuriat",
    understandCrisis: "Comprendre la crise",
    crisisTitle: "La Crise de la Main-d'œuvre et de l'Éducation en Chiffres",
    crisisSubtitle: "Statistiques critiques affectant l'employabilité et l'éducation des jeunes dans le monde",
    crisis: {
      inThree: "sur 3",
      stat1Label: "chômage des jeunes mondial (18-24 ans) vs. 5,8% adulte",
      stat2Label: "jeunes NON en éducation, emploi ou formation (NEET) dans le monde",
      stat3Label: "travailleurs sous-employés par rapport à leur éducation",
      stat4Label: "emplois nécessiteront des compétences numériques d'ici 2030",
      stat5Label: "inscription moyenne mondiale dans l'enseignement supérieur (plage: 15%-78%)",
      stat6Label: "jeunes en Afrique subsaharienne en dehors de la main-d'œuvre formelle",
      stat7Label: "temps quotidien moyen consacré au développement des compétences numériques",
      stat8Label: "chômage plus élevé dans les marchés émergents vs. développés",
    },
    severity: {
      crisis: "Crise",
      severe: "Sévère",
      concerning: "Préoccupant",
    },
    coreProblem: "Le Problème Central",
    coreProblemDesc: "Contrairement à la santé mentale (qui varie selon le bien-être individuel), les écarts de main-d'œuvre et d'éducation sont causés par des barrières structurelles: accès à une formation de qualité, disponibilité de l'infrastructure numérique, alignement du marché du travail avec les compétences enseignées et demande des employeurs pour des compétences spécifiques. Ce sont des problèmes solubles si JCI les aborde à grande échelle.",
    fiiTitle: "Méthodologie Main-d'œuvre du FII",
    fiiSubtitle: "Score Main-d'œuvre = 30% de l'Indice d'Impact Futur",
    subWeight: "sous-poids",
    globalAverage: "Moyenne mondiale",
    highest: "Plus élevé",
    lowest: "Plus bas",
    fii: {
      employmentRate: "Taux d'Emploi des Jeunes",
      employmentRateDef: "Pourcentage des 18-40 ans en emploi formel (excluant le travail précaire)",
      employmentHighest: "Pays Nordiques (85-90%)",
      employmentLowest: "Afrique subsaharienne (45-55%)",
      skillsAlignment: "Alignement des Compétences",
      skillsAlignmentDef: "Pourcentage de travailleurs dont les compétences correspondent aux exigences de l'emploi",
      skillsHighest: "Suisse, Allemagne (70-75%)",
      skillsLowest: "Asie du Sud (30-35%)",
      educationAccess: "Accès à l'Éducation",
      educationAccessDef: "Accès combiné à l'enseignement supérieur et aux programmes de formation professionnelle",
      educationHighest: "Corée du Sud, Finlande (78%)",
      educationLowest: "Niger, Tchad (15%)",
    },
    regionalTitle: "Scores Régionaux Main-d'œuvre",
    regionalSubtitle: "Dimension Main-d'œuvre du FII: Performance Régionale",
    regions: {
      europe: "Europe",
      asiaPacific: "Asie et le Pacifique",
      americas: "Amérique",
      africaMe: "Afrique et Moyen-Orient",
    },
    status: {
      good: "Bon",
      moderate: "Modéré",
      atRisk: "À Risque",
    },
    regional: {
      europeDrivers: "Systèmes de formation duale, éducation professionnelle forte",
      europeOpportunity: "Modèle pour les programmes de formation JCI",
      asiaPacificDrivers: "Variation économique: Japon/Corée élevé, Asie du Sud bas",
      asiaPacificOpportunity: "Alphabétisation numérique et partenariats de compétences tech",
      americasDrivers: "Amérique du Nord forte, Amérique latine a des lacunes",
      americasOpportunity: "Évolutivité des programmes JCI + CYE",
      africaMeDrivers: "Population jeune, pénurie d'infrastructure",
      africaMeOpportunity: "Plus grand impact potentiel—formation mobile-first",
    },
    employment: "Emploi",
    skillsLabel: "Compétences",
    education: "Éducation",
    projectionTitle: "Projection 2024 vs 2040",
    skillsTitle: "Paysage Mondial des Compétences",
    skillsSubtitle: "Analyse de l'écart entre l'offre et la demande de compétences",
    hardSkills: "Compétences Techniques",
    softSkills: "Compétences Comportementales",
    supply: "Offre",
    demand: "Demande",
    skillNames: {
      dataAnalytics: "Analyse de Données",
      cloudComputing: "Cloud Computing",
      aiMl: "IA/Machine Learning",
      cybersecurity: "Cybersécurité",
      projectMgmt: "Gestion de Projet",
      criticalThinking: "Pensée Critique",
      communication: "Communication",
      adaptability: "Adaptabilité",
      leadership: "Leadership",
      creativity: "Créativité",
    },
    deepDiveTitle: "Analyses Régionales Détaillées",
    deepDiveSubtitle: "Analyse approfondie de la main-d'œuvre et de l'éducation par région JCI",
    strengths: "Points Forts",
    challenges: "Défis",
    jciOpportunity: "Opportunité JCI",
    deepDive: {
      europe: {
        strength1: "Système d'éducation duale (Allemagne, Autriche, Suisse)",
        strength2: "Fort investissement en R&D et innovation",
        strength3: "Forte protection du travail et avantages",
        challenge1: "Vieillissement de la main-d'œuvre",
        challenge2: "Lacunes en compétences numériques dans certaines régions",
        challenge3: "Chômage des jeunes en Europe du Sud",
        opportunity: "Exporter les modèles de formation duale vers d'autres régions",
      },
      asiaPacific: {
        strength1: "Haute valorisation culturelle de l'éducation",
        strength2: "Adoption rapide de la technologie",
        strength3: "Main-d'œuvre jeune et croissante",
        challenge1: "Inégalité d'accès entre les pays",
        challenge2: "Inadéquation entre éducation et marché",
        challenge3: "Forte concurrence pour les emplois formels",
        opportunity: "Programmes de compétences numériques mobile-first",
      },
      americas: {
        strength1: "Écosystème d'innovation fort (États-Unis, Canada)",
        strength2: "Esprit entrepreneurial croissant",
        strength3: "Diversité des talents",
        challenge1: "Inégalité d'accès à une éducation de qualité",
        challenge2: "Coût élevé de l'enseignement supérieur",
        challenge3: "Sous-emploi des diplômés",
        opportunity: "Étendre les programmes JIB + CYE en Amérique latine",
      },
      africaMe: {
        strength1: "Population la plus jeune du monde",
        strength2: "Forte aspiration entrepreneuriale",
        strength3: "Croissance de l'écosystème numérique",
        challenge1: "Infrastructure éducative limitée",
        challenge2: "Chômage élevé des jeunes (14-16%)",
        challenge3: "Écart de financement critique",
        opportunity: "Formation mobile-first et microfinance pour les jeunes",
      },
    },
    initiativesTitle: "Initiatives Actuelles de JCI",
    initiativesSubtitle: "Programmes de main-d'œuvre et d'éducation de JCI",
    program: "Programme",
    reach: "Portée",
    target: "Public Cible",
    statusLabel: "Statut",
    initiatives: {
      jibName: "JCI Jeunes en Affaires (JIB)",
      jibTarget: "Jeunes entrepreneurs (18-30)",
      jibDesc: "Formation à la littératie commerciale et lancement de startups",
      cyeName: "Entrepreneuriat Jeunesse Créatif (CYE)",
      cyeTarget: "Jeunes créatifs (16-25)",
      cyeDesc: "Programme de compétences créatives et entrepreneuriat",
      digitalName: "Académie Numérique JCI",
      digitalTarget: "Tous les jeunes (18-40)",
      digitalDesc: "Formation aux compétences numériques et littératie technologique",
      mentoringName: "Réseau de Mentorat JCI",
      mentoringTarget: "Jeunes professionnels (22-35)",
      mentoringDesc: "Connexion mentor-mentoré pour le développement de carrière",
      riseName: "Projets RISE",
      riseTarget: "Communautés à risque",
      riseDesc: "Projets d'impact communautaire axés sur l'emploi",
      statusActive: "Actif",
      statusGrowing: "En Croissance",
      statusExpanding: "En Expansion",
    },
    outcomesTitle: "Résultats et Études de Cas",
    outcomesSubtitle: "Impact mesurable des programmes de main-d'œuvre JCI",
    cases: {
      paraguayCountry: "Paraguay",
      paraguayTitle: "JCI Asunción Digital Skills",
      paraguayOutcome: "Programme de formation numérique pour jeunes chômeurs avec un taux d'employabilité élevé",
      paraguayMetric: "taux d'employabilité",
      syriaCountry: "Syrie (Réfugiés)",
      syriaTitle: "JCI Refugee Skills Initiative",
      syriaOutcome: "Formation professionnelle pour jeunes réfugiés syriens dans les pays voisins",
      syriaMetric: "jeunes formés",
      boliviaCountry: "Bolivie",
      boliviaTitle: "JCI Santa Cruz Entreprend",
      boliviaOutcome: "Programme de micro-entrepreneuriat pour jeunes des communautés rurales",
      boliviaMetric: "entreprises lancées",
    },
    actionsTitle: "Actions Recommandées pour JCI",
    actionsSubtitle: "Priorités stratégiques pour combler l'écart de main-d'œuvre",
    actions: {
      action1Title: "Étendre l'Académie Numérique",
      action1Desc: "Étendre la formation aux compétences numériques à toutes les régions, en priorité Afrique/MO",
      action1Effort: "12-18 mois",
      action1Impact: "3x portée",
      action2Title: "Partenariats d'Entreprise",
      action2Desc: "Développer des partenariats avec les employeurs pour garantir des parcours d'emploi",
      action2Effort: "6-12 mois",
      action2Impact: "Employabilité +40%",
      action3Title: "Éducation Professionnelle",
      action3Desc: "Créer des programmes de formation professionnelle alignés sur le marché",
      action3Effort: "18-24 mois",
      action3Impact: "Modèle durable",
      action4Title: "Mentorat à l'Échelle",
      action4Desc: "Étendre le réseau de mentorat à 50 000+ connexions actives",
      action4Effort: "24-36 mois",
      action4Impact: "Développement de carrière",
      action5Title: "Certifications Reconnues",
      action5Desc: "Développer des certifications JCI reconnues par les employeurs mondiaux",
      action5Effort: "18-24 mois",
      action5Impact: "Crédibilité mondiale",
      action6Title: "Fonds de Microfinance",
      action6Desc: "Créer un fonds de microfinance pour les jeunes entrepreneurs des marchés émergents",
      action6Effort: "12-18 mois",
      action6Impact: "Accès au capital",
    },
    ctaTitle: "La Main-d'œuvre est l'Activateur",
    ctaDescription: "Main-d'œuvre et éducation relient la santé mentale (fondation) à l'entrepreneuriat (accélérateur). Les jeunes employés ont une meilleure santé mentale, plus de confiance et la capacité de créer des entreprises.",
    exploreFII: "Explorer le FII",
    exploreMentalHealth: "Explorer Santé Mentale",
    dataSources: { title: "Sources de Données" },
  },
} as const;
